"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoHero = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const useScript_1 = __importDefault(require("../hooks/useScript"));
function VideoHero({ videoId, className, id }) {
    (0, useScript_1.default)('https://players.brightcove.net/1143621176001/nClcCXzWZo_default/index.min.js');
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('relative', className), id: id },
        react_1.default.createElement("div", { className: "z-10 absolute top-0 left-0 right-0 bottom-0 w-full h-full", style: {
                background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%)',
            } }),
        react_1.default.createElement("video-js", { style: { objectFit: 'cover' }, id: "myvbg", "data-account": "1143621176001", "data-player": "nClcCXzWZo", "data-embed": "default", controls: "", "data-video-id": videoId, "data-playlist-id": "", "data-application-id": "", class: "jumbo-video-hero pt-full w-full h-full md:max-h-[645px] md:h-screen md:pt-0 md:aspect-[5/2]" })));
}
exports.VideoHero = VideoHero;
